import { Card } from 'antd';
import React from 'react';

const CommonCard = (props) => {
  const { children, ...rest } = props;
  return <Card {...rest}>{children}</Card>;
};

export default CommonCard;
